<template>
	<div class="other_page_r collection-edit-page">
		<el-card class="card_box">
			<div slot="header" class="card_title">{{ isEdit ? "编辑活动合集" : "新增活动合集" }}</div>
			<el-form ref="form" :model="form" :rules="rules" label-width="110px" class="collection-form">
				<el-form-item label="合集标题" prop="title">
					<el-input v-model.trim="form.title" maxlength="200" show-word-limit />
				</el-form-item>
				<el-form-item label="活动地点" prop="location_type">
					<el-select v-model="form.location_type">
						<el-option label="线下活动" value="offline" />
						<el-option label="线上活动" value="online" />
					</el-select>
					<el-input v-model.trim="form.location" class="location-input" :placeholder="form.location_type === 'online' ? '请输入线上平台或地址' : '请输入具体活动地点'" />
				</el-form-item>
				<el-form-item label="活动类型" prop="event_category">
					<el-radio-group v-model="form.event_category">
						<el-radio label="web3">Web3</el-radio>
						<el-radio label="ai">AI</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="合集封面" prop="cover">
					<div v-if="form.cover" class="cover-uploaded">
						<img :src="form.cover" class="cover-preview" />
						<div class="cover-actions">
							<el-upload action="" :show-file-list="false" :http-request="uploadCover" :before-upload="beforeCoverUpload">
								<el-button size="small">重新上传</el-button>
							</el-upload>
							<el-button size="small" type="danger" plain @click="removeCover">删除</el-button>
						</div>
					</div>
					<el-upload
						v-else
						action=""
						drag
						:show-file-list="false"
						:http-request="uploadCover"
						:before-upload="beforeCoverUpload"
					>
						<i class="el-icon-upload" />
						<div class="el-upload__text">点击或拖拽上传合集封面</div>
					</el-upload>
					<div class="form-tip">推荐比例16:9，JPG/JPEG/PNG/WEBP，最大5MB</div>
				</el-form-item>
				<el-form-item label="合集说明" prop="description">
					<el-input v-model="form.description" type="textarea" :rows="5" maxlength="500" show-word-limit />
				</el-form-item>

				<el-divider content-position="left">合集活动</el-divider>
				<el-form-item label="添加ME活动">
					<el-button type="primary" plain icon="el-icon-plus" @click="openActivitySelector">选择活动</el-button>
					<el-upload
						v-if="isEdit"
						class="collection-import"
						action=""
						:show-file-list="false"
						accept=".xlsx"
						:before-upload="beforeImport"
						:http-request="importFile"
					>
						<el-button plain icon="el-icon-upload2" :loading="importing">导入模板</el-button>
					</el-upload>
					<span v-if="pendingImportFile" class="selected-tip">待保存导入：{{ pendingImportFile.name }}</span>
					<span v-if="selectedActivities.length" class="selected-tip">已选择 {{ selectedActivities.length }} 个待添加活动</span>
				</el-form-item>
				<el-form-item v-if="selectedActivities.length" label="待添加活动">
					<el-tag v-for="item in selectedActivities" :key="item.id" closable class="activity-tag" @close="removeSelectedActivity(item.id)">
						{{ item.id }} - {{ item.title }}
					</el-tag>
				</el-form-item>
				<el-form-item v-if="previewImportRows.length" label="待导入活动">
					<el-table :data="previewImportRows" border size="small" max-height="360">
						<el-table-column prop="title" label="活动标题" min-width="240" />
						<el-table-column prop="start_time" label="开始时间" width="170" />
						<el-table-column prop="address" label="地点" min-width="180" show-overflow-tooltip />
						<el-table-column prop="host" label="主办方" min-width="160" show-overflow-tooltip />
						<el-table-column prop="url" label="链接" min-width="200" show-overflow-tooltip />
					</el-table>
				</el-form-item>
				<el-form-item v-if="activities.length" label="已添加活动">
					<el-table :data="activities" border size="small">
						<el-table-column prop="id" label="ID" width="90" />
						<el-table-column prop="title" label="活动标题" />
						<el-table-column label="操作" width="90">
							<template slot-scope="scope"><el-button type="text" class="danger" @click="removeActivity(scope.row)">移除</el-button></template>
						</el-table-column>
					</el-table>
				</el-form-item>
				<el-form-item v-if="externalActivities.length" label="已导入活动">
					<el-table :data="externalActivities" border size="small">
						<el-table-column prop="title" label="活动标题" min-width="240" />
						<el-table-column prop="start_time" label="开始时间" width="170" />
						<el-table-column prop="location" label="地点" min-width="180" show-overflow-tooltip />
						<el-table-column label="链接" min-width="180" show-overflow-tooltip>
							<template slot-scope="scope">
								<a :href="scope.row.url" target="_blank" rel="noopener noreferrer">{{ scope.row.url }}</a>
							</template>
						</el-table-column>
						<el-table-column label="操作" width="90">
							<template slot-scope="scope"><el-button type="text" class="danger" @click="removeExternalActivity(scope.row)">移除</el-button></template>
						</el-table-column>
					</el-table>
				</el-form-item>
				<el-form-item v-if="importResult" label="最近导入">
					<el-alert :title="importSummary" type="success" :closable="false" show-icon />
					<div v-if="importResult.errors && importResult.errors.length" class="import-errors">
						<div v-for="item in importResult.errors" :key="`${item.row}-${item.title || ''}`">
							第 {{ item.row }} 行：{{ item.title || "未命名活动" }}，{{ item.message }}
						</div>
					</div>
				</el-form-item>

				<el-form-item>
					<el-button type="primary" :loading="saving" @click="submit">保存</el-button>
					<el-button @click="$router.push('/event/collections')">取消</el-button>
				</el-form-item>
			</el-form>
		</el-card>

		<el-dialog
			title="选择 ME 活动"
			custom-class="activity-selector-dialog"
			:visible.sync="activityDialogVisible"
			width="860px"
			:append-to-body="true"
			:close-on-click-modal="false"
		>
			<div class="selector-search">
				<el-input v-model.trim="activitySearch.admin_keyword" placeholder="输入活动标题或 ID" @keyup.enter.native="searchActivities" />
				<el-select v-model="activitySearch.event_category" placeholder="活动类型">
					<el-option label="全部" value="" />
					<el-option label="Web3" value="web3" />
					<el-option label="AI" value="ai" />
				</el-select>
				<el-button type="primary" @click="searchActivities">查询</el-button>
			</div>
			<el-table ref="activitySelector" v-loading="activityLoading" :data="activityOptions" border @selection-change="handleActivitySelection">
				<el-table-column type="selection" width="55" :selectable="canSelectActivity" />
				<el-table-column prop="id" label="ID" width="90" />
				<el-table-column prop="title" label="活动标题" />
				<el-table-column label="活动类型" width="100">
					<template slot-scope="scope">{{ scope.row.event_category === "ai" ? "AI" : "Web3" }}</template>
				</el-table-column>
				<el-table-column prop="start_time" label="开始时间" width="170" />
			</el-table>
			<pagination :total="activityTotal" :page.sync="activitySearch.page" :limit.sync="activitySearch.size" @pagination="loadActivityOptions" />
			<div slot="footer" class="selector-actions">
				<el-button @click="activityDialogVisible = false">取消</el-button>
				<el-button type="primary" @click="confirmActivitySelection">添加选中活动</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import {
	getEventCollection, createEventCollection, updateEventCollection,
	addCollectionActivities, importCollectionActivities, removeCollectionActivity,
	removeCollectionExternalActivity,
} from "@/api/eventCollections";
import { uploadImage } from "@/api/user";
import { activitylists } from "@/api/article";
import * as XLSX from "xlsx";

export default {
	name: "EventCollectionEdit",
	data() {
		return {
			saving: false,
			activities: [],
			externalActivities: [],
			selectedActivities: [],
			pendingImportFile: null,
			previewImportRows: [],
			importing: false,
			importResult: null,
			activityDialogVisible: false,
			activityLoading: false,
			activityOptions: [],
			activityTotal: 0,
			activitySelection: [],
			activitySearch: { page: 1, size: 10, admin_keyword: "", event_category: "" },
			form: { title: "", location_type: "offline", location: "", event_category: "", cover: "", description: "" },
			rules: {
				title: [{ required: true, message: "请输入合集标题", trigger: "blur" }],
				location_type: [{ required: true, message: "请选择活动地点形式", trigger: "change" }],
				event_category: [{ required: true, message: "请选择活动类型", trigger: "change" }],
				cover: [{ required: true, message: "请上传合集封面", trigger: "blur" }],
				description: [{ required: true, message: "请输入合集说明", trigger: "blur" }],
			},
		};
	},
	computed: {
		isEdit() { return Boolean(this.$route.query.id); },
		importSummary() {
			const result = this.importResult;
			return `共 ${result.total_rows} 行，成功导入 ${result.imported} 条，跳过重复 ${result.skipped_duplicates} 条，失败 ${result.failed} 条`;
		},
	},
	created() { if (this.isEdit) this.load(); },
	methods: {
		openActivitySelector() {
			this.activityDialogVisible = true;
			this.loadActivityOptions();
		},
		searchActivities() {
			this.activitySearch.page = 1;
			this.loadActivityOptions();
		},
		loadActivityOptions() {
			this.activityLoading = true;
			activitylists(this.activitySearch).then((res) => {
				if (res.code === 200) {
					this.activityOptions = res.data.list || [];
					this.activityTotal = Number(res.data.total || 0);
				}
			}).finally(() => { this.activityLoading = false; });
		},
		canSelectActivity(row) {
			return !this.activities.some(item => Number(item.id) === Number(row.id))
				&& !this.selectedActivities.some(item => Number(item.id) === Number(row.id));
		},
		handleActivitySelection(rows) {
			this.activitySelection = rows;
		},
		confirmActivitySelection() {
			if (!this.activitySelection.length) return this.$message.warning("请先选择活动");
			this.selectedActivities = this.selectedActivities.concat(this.activitySelection.filter(row => this.canSelectActivity(row)));
			this.activityDialogVisible = false;
			this.activitySelection = [];
		},
		removeSelectedActivity(id) {
			this.selectedActivities = this.selectedActivities.filter(item => Number(item.id) !== Number(id));
		},
		beforeImport(file) {
			if (!/\.xlsx$/i.test(file.name)) {
				this.$message.error("仅支持导入 .xlsx 文件");
				return false;
			}
			if (file.size > 10 * 1024 * 1024) {
				this.$message.error("导入文件不能超过 10MB");
				return false;
			}
			return true;
		},
		importFile(option) {
			const reader = new FileReader();
			reader.onload = (event) => {
				try {
					const workbook = XLSX.read(event.target.result, { type: "array", cellDates: true });
					const sheet = workbook.Sheets[workbook.SheetNames[0]];
					const headers = (XLSX.utils.sheet_to_json(sheet, { header: 1, defval: "" })[0] || []);
					const rows = XLSX.utils.sheet_to_json(sheet, { defval: "" });
					this.previewImportRows = rows.map((row, index) => ({
						row: index + 2,
						title: this.previewValue(this.getImportValue(row, ["title", "活动标题", "标题", "活动名称"])),
						address: this.previewValue(this.getImportValue(row, ["address", "地址", "地点", "活动地点"])),
						start_time: this.previewDate(this.getImportValue(row, ["start_time", "开始时间", "活动开始时间"])),
						end_time: this.previewDate(this.getImportValue(row, ["end_time", "结束时间", "活动结束时间"])),
						host: this.previewValue(this.getImportValue(row, ["host", "主办方", "主办单位"])),
						url: this.previewValue(
							this.getImportValue(row, ["url", "链接", "活动链接", "报名链接"]) ||
							this.getImportHyperlink(sheet, index + 1, headers, ["url", "链接", "活动链接", "报名链接"])
						),
					}));
					this.pendingImportFile = option.file;
					this.importResult = null;
					this.$message.success("模板已选择，请确认活动后点击保存");
					if (option.onSuccess) option.onSuccess();
				} catch (error) {
					this.previewImportRows = [];
					this.$message.error("模板预览失败，请确认文件格式正确");
					if (option.onError) option.onError(error);
				}
			};
			reader.onerror = (error) => {
				this.$message.error("模板读取失败，请重试");
				if (option.onError) option.onError(error);
			};
			reader.readAsArrayBuffer(option.file);
		},
		getImportValue(row, keys) {
			const key = keys.find(item => Object.prototype.hasOwnProperty.call(row, item));
			return key ? row[key] : "";
		},
		getImportHyperlink(sheet, rowIndex, headers, keys) {
			const columnIndex = headers.findIndex(header => keys.includes(header));
			if (columnIndex < 0) return "";
			const cell = sheet[XLSX.utils.encode_cell({ r: rowIndex, c: columnIndex })];
			if (!cell) return "";
			return cell.l && (cell.l.Target || cell.l.display) || cell.w || cell.v || "";
		},
		previewValue(value) {
			return value === null || value === undefined ? "" : String(value).trim();
		},
		previewDate(value) {
			if (value instanceof Date && !Number.isNaN(value.getTime())) {
				const pad = number => String(number).padStart(2, "0");
				return `${value.getFullYear()}-${pad(value.getMonth() + 1)}-${pad(value.getDate())} ${pad(value.getHours())}:${pad(value.getMinutes())}:00`;
			}
			return this.previewValue(value);
		},
		beforeCoverUpload(file) {
			const validType = ["image/jpeg", "image/png", "image/webp"].includes(file.type);
			if (!validType) this.$message.error("仅支持 JPG、JPEG、PNG、WEBP 格式");
			if (file.size > 5 * 1024 * 1024) this.$message.error("合集封面不能超过 5MB");
			return validType && file.size <= 5 * 1024 * 1024;
		},
		uploadCover(option) {
			const data = new FormData();
			data.append("file", option.file);
			uploadImage(data).then((res) => {
				if (res.code === 200 && res.data && res.data.url) {
					this.form.cover = res.data.url;
					this.$refs.form.clearValidate("cover");
				} else {
					this.$message.error("图片上传失败，请重新上传");
				}
			}).catch(() => this.$message.error("图片上传失败，请重新上传"));
		},
		removeCover() {
			this.form.cover = "";
			this.$nextTick(() => this.$refs.form.validateField("cover"));
		},
		load() {
			getEventCollection(this.$route.query.id).then((res) => {
				if (res.code !== 200) return this.$message.error(res.message);
				Object.keys(this.form).forEach((key) => { this.form[key] = res.data[key] || ""; });
				this.activities = res.data.activities || [];
				this.externalActivities = res.data.external_activities || res.data.externalActivities || [];
			});
		},
		submit() {
			this.$refs.form.validate(async (valid) => {
				if (!valid) return;
				if (!this.form.location) return this.$message.error("请输入活动地点");
				this.saving = true;
				try {
					const response = this.isEdit ? await updateEventCollection(this.$route.query.id, this.form) : await createEventCollection(this.form);
					if (response.code !== 200) return this.$message.error(response.message);
					const id = response.data.id;
					if (this.selectedActivities.length) {
						const ids = this.selectedActivities.map(item => item.id).join(",");
						const relation = await addCollectionActivities(id, ids);
						if (relation.code !== 200) return this.$message.error(relation.message);
						const missing = relation.data.missing_ids || [];
						if (missing.length) this.$message.warning(`活动ID ${missing.join("、")} 不存在，其余有效活动已添加`);
					}
					if (this.pendingImportFile) {
						this.importing = true;
						try {
							const imported = await importCollectionActivities(id, this.pendingImportFile);
							if (imported.code !== 200) return this.$message.error(imported.message || "活动合集导入失败");
							this.importResult = imported.data;
							this.pendingImportFile = null;
							if (imported.data.failed) {
								this.$message.warning(`活动合集已保存，导入成功 ${imported.data.imported} 条，失败 ${imported.data.failed} 条`);
							} else {
								this.$message.success(`活动合集已保存，成功导入 ${imported.data.imported} 条活动`);
							}
						} finally {
							this.importing = false;
						}
					}
					this.$message.success(this.isEdit ? "活动合集更新成功" : "活动合集创建成功");
					this.$router.push("/event/collections");
				} catch (error) { this.$message.error(error.message); }
				finally { this.saving = false; }
			});
		},
		removeActivity(activity) {
			this.$confirm(`确认从当前合集中移除活动「${activity.title}」吗？`, "提示", { type: "warning" })
				.then(() => removeCollectionActivity(this.$route.query.id, activity.id))
				.then((res) => { if (res.code === 200) { this.$message.success("已移除"); this.load(); } else this.$message.error(res.message); })
				.catch((error) => { if (error !== "cancel") this.$message.error(error.message); });
		},
		removeExternalActivity(activity) {
			this.$confirm(`确认从当前合集中移除导入活动「${activity.title}」吗？`, "提示", { type: "warning" })
				.then(() => removeCollectionExternalActivity(this.$route.query.id, activity.id))
				.then((res) => { if (res.code === 200) { this.$message.success("已移除"); this.load(); } else this.$message.error(res.message); })
				.catch((error) => { if (error !== "cancel") this.$message.error(error.message); });
		},
	},
};
</script>

<style scoped>
.collection-form { max-width: 980px; margin: 24px auto; }
.location-input { width: calc(100% - 160px); margin-left: 12px; }
.cover-preview { display: block; width: 480px; max-width: 100%; aspect-ratio: 16 / 9; object-fit: cover; }
.cover-actions { display: flex; gap: 10px; margin-top: 12px; }
.form-tip { color: #909399; font-size: 12px; margin-top: 4px; }
.danger { color: #f56c6c; }
.selected-tip { margin-left: 12px; color: #606266; }
.collection-import { display: inline-block; margin-left: 12px; }
.activity-tag { margin: 0 8px 8px 0; max-width: 100%; }
.import-errors { margin-top: 10px; color: #f56c6c; font-size: 12px; line-height: 20px; }
.selector-search { display: flex; gap: 12px; margin-bottom: 16px; }
.selector-search .el-input { flex: 1; }
.selector-actions { display: flex; justify-content: flex-end; align-items: center; gap: 12px; }
.selector-actions .el-button + .el-button { margin-left: 0; }
</style>

<style>
.activity-selector-dialog.el-dialog {
	display: block !important;
	text-align: left;
}
.activity-selector-dialog .el-dialog__header {
	display: block;
	padding: 20px 20px 10px;
	text-align: left;
}
.activity-selector-dialog .el-dialog__body {
	width: auto;
	box-sizing: border-box;
	padding: 20px;
}
.activity-selector-dialog .el-dialog__footer {
	display: block;
	box-sizing: border-box;
	padding: 10px 20px 20px;
	text-align: right;
}

.collection-edit-page {
	height: calc(100vh - 80px);
	min-height: 0;
	overflow-x: hidden;
	overflow-y: auto;
	box-sizing: border-box;
}
.collection-edit-page .el-card {
	height: auto;
	min-height: 100%;
}
.collection-edit-page .collection-form {
	padding-bottom: 24px;
}
</style>
